import { styled } from "sharedUI/styles";

export const TitleArea = styled.div`
    display: flex;
    flex-direction: column;

    color: ${p => p.theme.fgColorDarkest};
    font-size: 13px;
    font-weight: 400;

    &.highlight {
        font-weight: 600;
        color: ${p => p.theme.b500};
        filter: drop-shadow(0 0 4px ${p => p.theme.b300});
    }
`;
